import { render, staticRenderFns } from "./ClientsView.vue?vue&type=template&id=2411682e&"
import script from "./ClientsView.vue?vue&type=script&lang=js&"
export * from "./ClientsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports